let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("9zLwF"), load("arhgZ"), load("jipsU")]).then(() => parcelRequire('hYKFX'));